exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".brand-logo img{max-width:100px!important}.required{color:red}.card-body{display:block;width:100%;overflow-x:auto}#loading-bg{z-index:1}.collapse-item-fixed-width{width:150px}.fab-wrapper{bottom:11vh!important;display:none}[dir=ltr] .fab-wrapper{right:22px!important}[dir=rtl] .fab-wrapper{left:22px!important}@media (max-width:767px){.fab-wrapper{display:block}}", ""]);

// exports
